
// Centralized navigation helpers to avoid direct window.location usage in components
// and to guard against reload loops.

export const safeReload = (reason?: string) => {
  try {
    const now = Date.now();
    const key = 'safe_reload_last_time';
    const last = localStorage.getItem(key);

    // Throttle reloads to avoid loops
    if (last && now - parseInt(last, 10) < 15000) {
      console.warn('safeReload: Skipping reload to avoid loop', { reason, last });
      return;
    }

    localStorage.setItem(key, now.toString());

    // Small delay to allow UI to update/toasts to show
    setTimeout(() => {
      window.location.reload();
    }, 100);
  } catch (e) {
    // Fallback hard reload
    window.location.reload();
  }
};

export const safeNavigate = (path: string, replace = false) => {
  try {
    const url = new URL(path, window.location.origin);

    // Only use History API for same-origin navigations
    if (url.origin === window.location.origin) {
      if (replace) {
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      } else {
        window.history.pushState({}, '', url.pathname + url.search + url.hash);
      }
      // Notify listeners (React Router) of the history change
      window.dispatchEvent(new PopStateEvent('popstate'));
      return;
    }

    // Cross-origin fallback
    if (replace) {
      window.location.replace(url.toString());
    } else {
      window.location.assign(url.toString());
    }
  } catch (e) {
    // If URL construction fails, fall back to direct navigation
    if (replace) {
      // @ts-ignore
      window.location.replace(path);
    } else {
      // @ts-ignore
      window.location.assign(path);
    }
  }
};

// Hard navigation with throttling, preserving cache-busting URLs (e.g., SW updates)
export const safeHardReplace = (url: string, reason?: string) => {
  try {
    const now = Date.now();
    const key = 'safe_reload_last_time';
    const last = localStorage.getItem(key);
    if (last && now - parseInt(last, 10) < 15000) {
      console.warn('safeHardReplace: Skipping to avoid loop', { reason, last });
      return;
    }
    localStorage.setItem(key, now.toString());
    window.location.replace(url);
  } catch (e) {
    // @ts-ignore
    window.location.replace(url);
  }
};
